// src/components/documents/ui/DocumentEditorUI.tsx
import { cn } from "@/lib/utils"

export const documentEditorTheme = {
  mainContainer: "flex flex-col h-full bg-purple-950/80 backdrop-blur-2xl border border-purple-300/40 rounded-3xl overflow-hidden shadow-2xl shadow-purple-500/20",

  header: "px-6 py-5 bg-purple-950/70 backdrop-blur-2xl border-b border-purple-300/40 flex items-center justify-between",

  headerIcon: "h-12 w-12 rounded-2xl bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center",

  title: "text-4xl font-bold text-white truncate max-w-[520px]",

  sidebar: "w-80 border-r border-purple-300/30 bg-purple-950/60 backdrop-blur-xl p-6 overflow-y-auto",

  sectionLabel: "text-lg text-purple-300 mb-3 font-medium",

  statusBadge: "text-xl px-6 py-2 bg-emerald-600 text-white rounded-2xl",

  descriptionTextarea: "min-h-[200px] bg-purple-950/60 border-purple-300/40 text-white resize-y rounded-3xl text-xl",

  // Кнопка "Сохранить описание"
  saveButton: "mt-4 w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white rounded-3xl py-7 text-xl font-medium shadow-lg shadow-purple-500/30",

  // Кнопка "Скачать оригинал"
  downloadButton: cn(
    "bg-purple-950/70 hover:bg-purple-950/90 border border-purple-300/40 text-white text-lg",
    "hover:border-purple-400 transition-all rounded-3xl px-6 py-3 flex items-center gap-2"
  ),

  viewerContainer: "flex-1 flex flex-col bg-purple-950/40",

  loadingContainer: "flex-1 flex items-center justify-center",

  noFileMessage: "flex-1 flex items-center justify-center text-purple-400 text-xl",

  iframeContainer: "flex-1 relative",
} as const